"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyTrainerAdminList = void 0;
exports.trainerAdminListSetMock = trainerAdminListSetMock;
exports.trainerAdminList = trainerAdminList;
exports.useQueryTrainerAdminList = useQueryTrainerAdminList;
exports.useInfiniteQueryTrainerAdminList = useInfiniteQueryTrainerAdminList;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function trainerAdminListSetMock(mock) {
    setMock = mock;
}
async function trainerAdminList(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/v1/admin/trainer`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params, 'trainer-store')
        : client.getRequestConfig(params, 'trainer-store');
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.perPage = params.perPage;
    queryParams.page = params.page;
    queryParams.ids = params.ids;
    queryParams.firstName = params.firstName;
    queryParams.lastName = params.lastName;
    queryParams.sortAsc = params.sortAsc;
    queryParams.sortDesc = params.sortDesc;
    queryParams.getAll = params.getAll;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.trainerStoreIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyTrainerAdminList = 'trainer-store:trainerAdminList:get';
function useQueryTrainerAdminList(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyTrainerAdminList, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryTrainerAdminList(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyTrainerAdminList, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = trainerAdminList(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=trainer-admin-list.js.map